import { Relationship } from "./relationship";
import { JsonapiProvider } from './../../providers/jsonapi/jsonapi';

export class HasOne extends Relationship{
    
        constructor(api: JsonapiProvider, data: any){
            super(api);

            this.fill(data);
        }


        public fill(data){
            this.data = data.data;
            this.links = data.links;

            return this;
        }
    

        public key(){
            return this.data.id;
        }
    
    
}
